// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { format } from "../utils/format";
import instadate from 'instadate';
import Select from '../form/select.js';

import { formActions, mergeActionsToProps } from 'redux-pure-form';
import CardsBlock from '../card/cards-block.js';

import type { MapStateToProps } from 'react-redux';
import { getOption } from '../form/select.js';

import history from '../history/history.js';
import TransactionsTable from './transactions.table.js';

import Indication from '../ui/indication.js';
import Icon from '../icon/icon.js';
import Breadcrumbs from '../breadcrumbs/breadcrumbs.js';

import type { InputMessages } from '../ui/ui.types.js';

import {
  transactionsSelector,
  transactionsListSelector,
  creditsSelector,
  creditsListSelector
} from './transaction.selectors.js';
import TransactionCreditModifyModal from './transaction-credit-modify.modal.js';

import { payerSelector, userSelector } from '../user/user.selectors.js';
import { invoicesSelector } from '../invoice/invoice.selectors.js';
import { balanceByOrgListSelector } from '../balance/balance.selectors.js';

import {
  productsSelector,
  productsListSelector,
  productsOptionsSelector
} from '../products/products.selectors.js';

import {
  organizationsSelector,
  organizationSelector
} from '../organization/organization.selectors.js';

import { getTransactions, addCredit, saveCredit, deleteCredit } from './transaction.actions.js';

import { selectUIModal, selectUIMessages, selectUIProgress } from '../ui/ui.helpers.js';
import { setModal } from '../ui/ui.actions.js';

import { MODAL_CREDIT } from './transaction.const.js';
import { monthsOptions } from '../calendar/calendar.consts.js';
import Organization from '../organization/organization.model.js';
import Invoice from '../invoice/invoice.model.js';
import Transaction from './transaction.model.js';
import Calendar from '../calendar/calendar.model.js';
import Url from '../url/url.model.js';
import PayerNameBlock from '../payments/payer-name.block.js';

const yearsOptions = Calendar.getYearsOptions();
const transactionsOptions = [
  getOption('All', 'All'),
  getOption('Credits', 'Credits'),
  getOption('Invoices', 'Invoices'),
  getOption('Payments', 'Payments')
];

type OwnProps = {|
  transactions?: boolean,
  transactions?: boolean
|};

type MappedState = {|
  URL: $ElementType<ReduxState, 'URL'>,
  messages: InputMessages,
  progress: boolean,
  user: $ElementType<ReduxState, 'user'>,
  payer: $ElementType<ReduxState, 'payer'>,
  organization: $ElementType<ReduxState, 'organization'>,
  organizations: $ElementType<ReduxState, 'organizations'>,
  transactions: $ElementType<ReduxState, 'transactions'>,
  invoices: $ElementType<ReduxState, 'invoices'>,
  transactionsList: List,
  credits: $ElementType<ReduxState, 'credits'>,
  creditsList: List,
  product: $ElementType<ReduxState, 'product'>,
  productList: List
|};

type Props = {|
  ...OwnProps,
  ...MappedState,
  getTransactions: typeof getTransactions,
  addCredit: typeof addCredit,
  saveCredit: typeof saveCredit,
  deleteCredit: typeof deleteCredit,
  fieldAttrs: FieldAttrs
|};

type State = {||};

export function CreditsTable({
  list,
  credits,
  organizations,
  showOrgColumn,
  products,
  onEdit,
  onDelete
}) {
  if (!list.length) return null;

  return (
    <div className="panel panel-default">
      <div className="table-responsive">
        <table className="table table-sm table-hover table-panel">
          <thead>
            <tr>
              <th className={`text-left col-md-${showOrgColumn ? '1' : '2'}`}>Credit</th>
              {showOrgColumn ? (
                <th className={`text-left col-md-${showOrgColumn ? '2' : '3'}`}>Organization</th>
              ) : null}
              <th className="text-right col-md-1">Product/Service</th>
              <th className="text-right col-md-1">Amount</th>
              <th className="text-right col-md-2">Date</th>
              {Organization.orgAccess ? <th className="text-right col-md-2">Actions</th> : null}
            </tr>
          </thead>
          <tbody>
            {list.map(id => {
              const credit = credits[id];
              const org = organizations[credit.organizationId];

              if (!org) return null;

              return (
                <tr key={`credit-${id}`}>
                  <td className={`text-left col-md-${showOrgColumn ? '1' : '2'}`}>#{id}</td>
                  {showOrgColumn ? (
                    <td className={`text-left col-md-${showOrgColumn ? '2' : '3'}`}>{org.name}</td>
                  ) : null}
                  <td className="text-right col-md-1">{products[credit.productId].name}</td>
                  <td className="text-right col-md-1">${credit.amount}</td>
                  <td className="text-right col-md-2">{credit.createdDateTime}</td>
                  {Organization.orgAccess ? (
                    <td className="text-right col-md-2">
                      <button
                        id={id}
                        className="btn btn-xs btn-success btn-add-card"
                        data-amount={credit.amount}
                        data-product-id={credit.productId}
                        onClick={onEdit}
                      >
                        Edit
                      </button>
                      <button
                        id={id}
                        className="btn btn-xs btn-danger btn-add-card"
                        onClick={onDelete}
                      >
                        Delete
                      </button>
                    </td>
                  ) : null}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

class TransactionsScreen extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    const fromDate = this.props.URL.fromDate ? new Date(this.props.URL.fromDate) : new Date();

    this.state = {
      filter: {
        month: fromDate.getMonth(),
        year: fromDate.getFullYear(),
        type: 'All'
      },
      credit: {
        id: '',
        productId: '',
        amount: '',
        action: ''
      }
    };

    this.onHistoryChange = this.onHistoryChange.bind(this);

    this.openModal = this.props.setModal.bind(this, true, MODAL_CREDIT);
    this.closeModal = this.props.setModal.bind(this, false, MODAL_CREDIT);

    this.onAddCreditOpen = this.onAddCreditOpen.bind(this);
    this.onEditCreditOpen = this.onEditCreditOpen.bind(this);

    this.onSelectProduct = this.onSelectProduct.bind(this);
    this.onCreditAmountChange = this.onCreditAmountChange.bind(this);

    this.onSubmitCredit = this.onSubmitCredit.bind(this);
    this.onDeleteCredit = this.onDeleteCredit.bind(this);

    this.onFilterChange = this.onFilterChange.bind(this);
    this.onFilter = this.onFilter.bind(this);
  }

  componentDidMount() {
    window.onpopstate = this.onHistoryChange;
  }

  componentWillUnmount() {
    window.onpopstate = null;
  }

  onHistoryChange: Function;
  onHistoryChange() {
    const fromDateUrl = Url.getFromDateFilter();

    const fromDate = fromDateUrl ? new Date(fromDateUrl) : new Date();

    this.setState({
      ...this.state.credit,
      filter: {
        month: fromDate.getMonth(),
        year: fromDate.getFullYear()
      }
    });

    this.onFilter();
  }

  onSelectProduct: Function;
  onSelectProduct(value) {
    return this.setState({
      credit: {
        ...this.state.credit,
        productId: value
      }
    });
  }

  onEditCreditOpen: Function;
  onEditCreditOpen(e) {
    const { productId, amount } = e.currentTarget.dataset;
    this.setState({
      credit: {
        action: 'edit',
        id: e.currentTarget.id,
        productId,
        amount
      }
    });

    return this.openModal();
  }

  onAddCreditOpen: Function;
  onAddCreditOpen(value) {
    this.setState({
      credit: {
        ...this.state.credit,
        action: 'add'
      }
    });

    return this.openModal();
  }

  onCreditAmountChange: Function;
  onCreditAmountChange(e) {
    return this.setState({
      credit: {
        ...this.state.credit,
        amount: e.currentTarget.value
      }
    });
  }

  onSubmitCredit: Function;
  onSubmitCredit(e) {
    e.preventDefault();

    return this.state.credit.action === 'add'
      ? this.props.addCredit(this.state.credit)
      : this.props.saveCredit(this.state.credit);
  }

  onDeleteCredit: Function;
  onDeleteCredit(e) {
    return confirm('Are you sure?') ? this.props.deleteCredit(e.currentTarget.id) : false;
  }

  onFilterChange: Function;
  onFilterChange(e) {
    return this.setState({
      filter: {
        ...this.state.filter,
        [e.currentTarget.name]: e.currentTarget.value
      }
    });
  }

  onFilter: Function;
  onFilter(e) {
    const filterDate = new Date(
      parseInt(this.state.filter.year, 10),
      parseInt(this.state.filter.month, 10)
    );

    const filterParams = `${format(instadate.firstDateInMonth(filterDate), 'Y-m-d')}/${format(
      instadate.lastDateInMonth(filterDate),
      'Y-m-d'
    )}`;

    if (e && e.currentTarget.id === 'filter') {
      history.push(
        Organization.orgAccess
          ? `/org/${this.props.organization.unique}/transactions/users/${this.props.payer.id}/${filterParams}/`
          : `/transactions/${filterParams}/`
      );
    }

    return this.props.getTransactions(filterParams);
  }

  render() {
    const {
      URL,
      progress,
      messages,
      payer,
      organization,
      organizations,
      transactionsList,
      balanceByOrgList
    } = this.props;

    if (!payer) return null;

    return (
      <div>
        <Breadcrumbs />

        <Indication closable messages={messages} className="message-indicator" />

        <TransactionCreditModifyModal type="add" />

        <div className="invoices-container">
          {Organization.orgAccess ? (
            <PayerNameBlock
              payer={payer}
              organization={organizations[organization.id]}
              payerBalance={payer.balanceByOrg[organization.id]}
            />
          ) : (
            <CardsBlock>
              <div className="payer-info">
                <div className="payer-balance-item-wrap">
                  {balanceByOrgList.map(orgId =>
                    organizations[orgId] ? (
                      <div key={`balance-org-${orgId}`} className="payer-balance-item">
                        <span className="payer-balance-item-label">
                          {organizations[orgId].name} Balance
                        </span>
                        <span className="payer-balance">${payer.balanceByOrg[orgId].balance}</span>
                      </div>
                    ) : null
                  )}
                  <div className="payer-balance-item">
                    <span className="payer-balance-item-label">Total Balance</span>
                    <span className="payer-balance">
                      $
                      {balanceByOrgList.reduce(
                        (acc, orgId) => acc + parseFloat(payer.balanceByOrg[orgId].balance),
                        0
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </CardsBlock>
          )}
          {/* пока не используется HOLD-2415
            <div className="heading-block credits-block">
              <div className="heading-block-name">
                <Icon
                  width="12px"
                  height="14px"
                  name="card"
                  className="icon-primary"
                />
                <span className="heading-text">Credits</span>
              </div>
            </div>
            <div className="credit-table-wrap">
              {
                creditsList.length ? (
                  <CreditsTable
                    list={creditsList}
                    credits={credits}
                    organizations={organizations}
                    showOrgColumn={(user.id === payer.id) || !Organization.orgAccess}
                    products={products}
                    onEdit={this.onEditCreditOpen}
                    onDelete={this.onDeleteCredit}
                  />
                ) : (
                  <div>There are no cretidts yet</div>
                )
              }
            </div>
          */}

          <div className="invoices-paid-block">
            <div className="heading-block">
              <div className="heading-block-name">
                <Icon width="12px" height="14px" name="card" className="icon-primary" />
                <span className="heading-text">Transactions</span>
              </div>

              <div className="invoice-transaction-toggle">
                <div className="btn-group">
                  {URL.model === 'invoices' ? (
                    <span>
                      <div className="btn btn-xs btn-info btn-invoices">Invoices</div>
                      <a
                        href={Transaction.getListLink(payer.id, organization.unique)}
                        className="btn btn-xs btn-default btn-transactions"
                      >
                        Transactions
                      </a>
                    </span>
                  ) : (
                    <span>
                      <a
                        href={Invoice.getListLink(payer.id, organization.unique)}
                        className="btn btn-xs btn-default btn-invoices"
                      >
                        Invoices
                      </a>
                      <div className="btn btn-xs btn-info btn-transactions">Transactions</div>
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="panel panel-default invoices-filter-block">
              <div className="filer-item filter-lebel">Filter by Month</div>

              <div className="filer-item select">
                <Select
                  name="month"
                  className="form-control"
                  options={monthsOptions}
                  value={this.state.filter.month}
                  onChange={this.onFilterChange}
                />
              </div>

              <div className="filer-item select">
                <Select
                  name="year"
                  className="form-control"
                  options={yearsOptions}
                  value={this.state.filter.year}
                  onChange={this.onFilterChange}
                />
              </div>

              <button
                id="filter"
                className="btn btn-success"
                onClick={this.onFilter}
                disabled={progress}
              >
                <span className="icon search" /> Filter
              </button>

              <div className="filer-item filter-lebel filter-lebel-right">
                Filter by Type Transactions
              </div>
              <div className="filer-item select">
                <Select
                  name="type"
                  className="form-control"
                  options={transactionsOptions}
                  value={this.state.filter.type}
                  onChange={this.onFilterChange}
                />
              </div>
            </div>

            {Organization.orgAccess ? (
              <button
                className="btn btn-xs btn-success btn-add-card"
                onClick={this.onAddCreditOpen}
              >
                Add credit
              </button>
            ) : null}

            {transactionsList.length ? (
              <TransactionsTable transactionsView filter={this.state.filter.type} />
            ) : (
              <div className="panel panel-default no-panel-block">
                <h4 className="text-center no-panel-text">
                  There aren't any transactions yet for selected month.
                </h4>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const progressSelector = selectUIProgress();
const messagesSelector = selectUIMessages();
const modalSelector = selectUIModal(MODAL_CREDIT);

const mapStateToProps: MapStateToProps<ReduxState, OwnProps, MappedState> = state => ({
  URL: state.URL,
  progress: progressSelector(state),
  messages: messagesSelector(state),
  addCreditModal: modalSelector(state),
  user: userSelector(state),
  payer: payerSelector(state),
  organization: organizationSelector(state),
  organizations: organizationsSelector(state),
  transactions: transactionsSelector(state),
  transactionsList: transactionsListSelector(state),
  credits: creditsSelector(state),
  creditsList: creditsListSelector(state),
  products: productsSelector(state),
  productsList: productsListSelector(state),
  productsOptions: productsOptionsSelector(state),
  invoices: invoicesSelector(state),
  accessgroups: state.accessgroups,
  balanceByOrgList: balanceByOrgListSelector(state)
});

export default connect(
  mapStateToProps,
  {
    ...formActions,
    getTransactions,
    addCredit,
    saveCredit,
    deleteCredit,
    setModal
  },
  mergeActionsToProps
)(TransactionsScreen);
